import { createTheme } from '@mui/material/styles';

// The look shared by the landing page (landing/Landing.css) and the map app:
// one ink, one blue, one green, and the same three typefaces.
export const BRAND = {
    ink:'#14231f', mute:'#5b6b66', line:'#dde4e1', bg:'#fbfcfb', tint:'#eef7f2',
    blue:'#1f4fbf', green:'#1f7a5a',
};
export const BODY_FONT = '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", Arial, sans-serif';
export const DISPLAY_FONT = '"Bricolage Grotesque Variable", "IBM Plex Sans", system-ui, sans-serif';
export const MONO_FONT = '"IBM Plex Mono", ui-monospace, Menlo, monospace';

// The street sign logo (components/Logo.js and the favicons in public/): a white plate
// with a black border and "UK" in red, in Barlow Semi Condensed (bundled in index.css).
export const SIGN = {ink:'#111111', plate:'#ffffff', red:'#C8202A', edge:'#d6d0c4'};
export const SIGN_FONT = '"Barlow Semi Condensed", "IBM Plex Sans", system-ui, sans-serif';

// The areas compared in the price, crime and economics charts, from the local
// area outwards: ink for the area itself, then blue, then two quieter greys.
export const GEO_COLORS = {local:BRAND.ink, surrounding:BRAND.green, lad:BRAND.blue, rgn:'#7fa89a', ctry:'#a9b4b0'};

// A round icon button in a panel's header (the area overview's save, share and
// close): ink on white with a fine border, tinted green on hover. Pass active for
// a button that is switched on, such as the bookmark of a saved location.
export const iconActionSx = (active=false) => ({
    width:36, height:36, padding:0, flexShrink:0,
    border:'1px solid '+(active ? '#b9dccb' : BRAND.line), borderRadius:'50%',
    backgroundColor:active ? BRAND.tint : '#fff', color:active ? BRAND.green : BRAND.ink,
    transition:'background-color .15s, border-color .15s, color .15s',
    '&:hover':{backgroundColor:BRAND.tint, borderColor:BRAND.green, color:BRAND.green},
    '&:focus-visible':{outline:'2px solid '+BRAND.blue, outlineOffset:1},
    '& .MuiSvgIcon-root':{fontSize:20},
});

const heading = {fontFamily:DISPLAY_FONT, fontWeight:700, letterSpacing:'-0.01em'};

const theme = createTheme({
    palette: {
        primary: {main:BRAND.blue},
        secondary: {main:BRAND.green},
        text: {primary:BRAND.ink, secondary:BRAND.mute},
        divider: BRAND.line,
    },
    shape: {borderRadius:8},
    typography: {
        fontFamily: BODY_FONT,
        h1:heading, h2:heading, h3:heading, h4:heading, h5:heading, h6:heading,
        button: {textTransform:'none', fontWeight:600},
    },
    components: {
        MuiDialog: {styleOverrides: {paper: {borderRadius:12}}},
        MuiDialogTitle: {styleOverrides: {root: heading}},
        MuiTab: {styleOverrides: {root: {textTransform:'none', fontWeight:600}}},
        MuiTooltip: {styleOverrides: {tooltip: {backgroundColor:BRAND.ink, fontFamily:BODY_FONT}}},
    },
});

export default theme;
